import { CompetitionPayload } from 'models/endpoints-payload'
import { CompetitionResponse } from 'models/endpoints-respone'

import { promiseWrapper } from 'utils/promise'

declare const USER_BASE_URL_WT: string

const competitionSubscribe = (payload: CompetitionPayload): Promise<CompetitionResponse> => {
  return promiseWrapper<CompetitionResponse, CompetitionPayload>(
    `${USER_BASE_URL_WT}/api/public/cmsEmailSubscribe`,
    'POST',
    payload,
  )
}

export default competitionSubscribe
